import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Album from "models/Album";
import TrebbleAlbumListView from "views/common/TrebbleAlbumListView";
import Albums from "collections/myLibrary/AlbumsTabContentCollection";
import PersistentModels from "services/PersistentModels";
import RSVP from "rsvp";

const AlbumListView = Backbone.View.extend({
    
    
    
    
    
    initialize: function(options) {
        this.displayedCollection = this.collection;
        this.collection.bind("add", this._onAlbumAddedOrRemoved, this);
        this.collection.bind("change", this._onAlbumUpdated, this);
        this.collection.bind("remove", this._onAlbumAddedOrRemoved, this);
        this.collection.bind("reset", this._onAlbumAddedOrRemoved, this);
        this._delayOnCollectionUpdate = (options && options.delayOnCollectionUpdate) ? options.delayOnCollectionUpdate :  1000;
        this._resizeToAvailableScreenSizeOnOrientationChange = options  ? options.resizeToAvailableScreenSizeOnOrientationChange :  true;
        this._showHeader = options  ? options.showHeader :  false;
        this._headerText= options  ? options.headerText :  "";
        this._showFooter= options  ? options.showFooter :  false;
        this._footerText= options  ? options.footerText :  "";
        this._container$elForImageLazyLoad = options? options.container$elForImageLazyLoad: null;
        this._customInfoBoxInfoParams = options ? options.customInfoBoxInfoParams : null;
        this._loadHandler= (options && options.loadHandler)  ? options.loadHandler :  null;
        this._heightMargin= (options && options.heightMargin)  ? options.heightMargin :  null;
        this._showEmtptyInfoBox = (options && options.showEmtptyInfoBox)  ? options.showEmtptyInfoBox :  null;
        this._resizePlaceHolderElem =  options  ? options.resizePlaceHolderElem :  false;
        this._doNotSortDisplayedCollection =  options  ? options.doNotSortDisplayedCollection :  true;
        this._doNotShowLoadingWidgetDuringListLoading = options  ? options.doNotShowLoadingWidgetDuringListLoading :  false;
        this._listenerViewportKey = "albumListView" + (new Date()).getTime();
        this._doNotInitializeLazyLoadingAtRender = options? options.doNotInitializeLazyLoadingAtRender: false;
        PersistentModels.getInstance().getRouter().registerForViewportHeightChange(this._listenerViewportKey,this._onOrientationChangeFunction.bind(this));
        
    },
    
_onOrientationChangeFunction : function(newViewPortHeigh, forceResizing) {
    if(this.$el.is(":visible") || forceResizing){
        if(this._heightMargin){
            newViewPortHeigh = newViewPortHeigh - this._heightMargin;
        }
       if (!this._resizePlaceHolderElem && this.$el) {
        this.$el.css("height" , (newViewPortHeigh ) + "px"); 
       }
       this.infiniteListView._onRootElementResize();
    }
},


filterList: function(searchCharaterers) {
 if(!this._removeFromDom){
    this.appliedSearchCharacters = searchCharaterers;
    const searchFunction = (function() {
        $.mobile.loading("show");
        this.infiniteListView.setUpdating(true);
        const r  = this.collection.searchOnAlbumTitleAndArtistname(this.appliedSearchCharacters);
        if(r instanceof RSVP.Promise){
            r.then((function(arrayOfResults){
                const albumCollection = new Albums(arrayOfResults);
                albumCollection.updateContext(this.displayedCollection.getContext());
                this._changeAlbumList(albumCollection);
                this.pendingSearchFunctionTimerId = null;
                $.mobile.loading("hide");
            }).bind(this)).catch((function(error){
                $.mobile.loading("hide");
                window.alertErrorMessage(error);
            }).bind(this));
        }else{
            const albumCollection = new Albums(r);
            albumCollection.updateContext(this.displayedCollection.getContext());
            this._changeAlbumList(albumCollection);
            this.pendingSearchFunctionTimerId = null;
            $.mobile.loading("hide");
        }
        
    }).bind(this);
    if (this.pendingSearchFunctionTimerId) 
    {
        window.clearTimeout(this.pendingSearchFunctionTimerId);
    }
    this.pendingSearchFunctionTimerId = window.setTimeout(searchFunction,  this._delayOnCollectionUpdate);
}
},

clearSearchfilter: function() {
if(!this._removeFromDom){
    this.appliedSearchCharacters = null;
    const searchFunction = (function() {
        this.infiniteListView.setUpdating(true);
        const albumCollection = new Albums(this.collection.searchOnAlbumTitleAndArtistname(""));
        albumCollection.updateContext(this.displayedCollection.getContext());
        this._changeAlbumList(albumCollection);
        this.pendingSearchFunctionTimerId = null;
    }).bind(this);
    if (this.pendingSearchFunctionTimerId) 
    {
        window.clearTimeout(this.pendingSearchFunctionTimerId);
    }
    this.pendingSearchFunctionTimerId = window.setTimeout(searchFunction, 0);
}

},


_changeAlbumList: function(newAlbumModels) {
if(!this._removeFromDom){
    this.displayedCollection = newAlbumModels;
    if(!this._doNotSortDisplayedCollection)
    {
        this.displayedCollection.sort();
    }
    this.infiniteListView.updateModels(this.displayedCollection.toJSON());
    this.infiniteListView.setUpdating(false);
}
},

_updateAlbumInAlbumList: function(albumUpdateModel) {
if(!this._removeFromDom){
    this.infiniteListView.updateModel(albumUpdateModel.toJSON());
    this.infiniteListView.setUpdating(false);
}
},

_getOnListItemTapHandler: function() {
return (function(albumJson, evnt, item) {
    this.trigger("albumInfoTapped", this._getAlbumModelFromAlbumJson(albumJson) ,this.displayedCollection );
}).bind(this);
},

_getOnItemActionButtonTappedHanlder: function() {
return (function(albumJson, evnt, item) {
   this.trigger("albumActionButtonTapped", this._getAlbumModelFromAlbumJson(albumJson));

}).bind(this);
},

_getAlbumModelFromAlbumJson : function(albumJon){
return this.collection.get(albumJon.albumId);

},


isSearchApplied : function(){
return this.appliedSearchCharacters != null;
},

getAppliedSearchCharacters : function(){
return this.appliedSearchCharacters;
}, 

_onAlbumAddedOrRemoved : function(){
if(!this._removeFromDom){
if(this.isSearchApplied())
{
  this.filterList(this.getAppliedSearchCharacters());
}else{
  this.infiniteListView.setUpdating(true);
  this._changeAlbumList(this.collection);
}
this.trigger("modelChange", this.collection);
}
},

_onAlbumUpdated : function(albumUpdateModel){
if(!this._removeFromDom){
if(this.isSearchApplied())
{
  this.filterList(this.getAppliedSearchCharacters());
}else{
  this.infiniteListView.setUpdating(true);
  this._updateAlbumInAlbumList(albumUpdateModel);
}
this.trigger("modelChange", this.displayedCollection);
}
},


isCollectionEmpty : function(){
if(this.collection)
{
return this.collection.length == 0;
}else{
return true;
}
},

_onContentLoading : function(){
if(!this._doNotShowLoadingWidgetDuringListLoading){
$.mobile.loading( 'show');
}
},

_onContentLoaded : function(){
if(!this._doNotShowLoadingWidgetDuringListLoading){
$.mobile.loading( "hide" );
}
},

_onContentFailedLoading : function(error){
if(!this._doNotShowLoadingWidgetDuringListLoading){
$.mobile.loading( "hide" );
console.error("Page content failed loading. Error:"+error);
}
},

load : function(params){
if(!this._removeFromDom){
if(this._loadHandler){
  this._onContentLoading();
  try{
     this.infiniteListView.setUpdating(true);
     return this._loadHandler(params).then((function(arrayOfAlbums){
         if(!this._removeFromDom){
            this.collection.reset(arrayOfAlbums);
            this.infiniteListView.setUpdating(false);
        }
        this._onContentLoaded();
    }).bind(this)).catch((function(error){
        this._onContentFailedLoading(error);
        this.infiniteListView.setErrorMessage(error);
    }).bind(this));
}catch(error){
 this._onContentFailedLoading(error);
 this.infiniteListView.setErrorMessage(error);
}
}else{
this._onAlbumAddedOrRemoved();
return RSVP.Promise.resolve();
}
}
},

updateInfoBoxIfApplicable : function(iconClass,message,helpMessage,infoBoxClassName,actionButtonLabel,actionButtonIconClass){
if(this.infiniteListView){
this.infiniteListView.update(iconClass,message,helpMessage,infoBoxClassName,actionButtonLabel,actionButtonIconClass);
}
},

_onNodeRemovedFromDom : function(){
this._removeFromDom  = true;
PersistentModels.getInstance().getRouter().unRegisterForViewportHeightChange(this._listenerViewportKey);
},

/*onSongRemovedFromTrebble : function(songModel){
this.trigger("songRemovedFromTrebble",songModel);
},

onActionExecutedOnSongHandler : function( songModel, action){
this.trigger("actionExecutedOnSongHandler",songModel, action);
},*/

buildItemEventHandler : function(){
const handlers = {};
handlers["click .songInfo"] = this._getOnListItemTapHandler();
handlers["click div.actionButtonWrapper > #actionButton"] = this._getOnItemActionButtonTappedHanlder();
return handlers;
},

initializeImageLazyLoadPlugin : function(container$elForImageLazyLoad){
this.infiniteListView.initializeImageLazyLoadPlugin(container$elForImageLazyLoad);
},

cancelPendingImageLoading : function(){
this.infiniteListView.cancelPendingImageLoading();
},


render: function() {

let newViewPortHeigh = PersistentModels.getInstance().getRouter().getViewportHeight();
if(this._heightMargin){
newViewPortHeigh = newViewPortHeigh - this._heightMargin;
}
this.$el.html(' <div id="maliste"  style="height:' +(newViewPortHeigh + "px") + ';overflow:hidden;width:100%"></div>');
this.setElement(this.$el.find("div").first());
const listParams = {};
if(!this._doNotSortDisplayedCollection)
{
this.displayedCollection.sort();
}
listParams.model = this.displayedCollection.toJSON();
listParams.collection = this.displayedCollection;
listParams.listRootElement = this.el;
listParams.defaultNumberOfElements = 80;
listParams.defaultHeightElement = 60;
listParams.placeHolderHeight =  PersistentModels.getInstance().getRouter().getViewportHeight();
listParams.resizePlaceHolderElem =  this._resizePlaceHolderElem;
listParams.showEmtptyInfoBox = this._showEmtptyInfoBox;
listParams.customInfoBoxInfoParams = this._customInfoBoxInfoParams;
listParams.itemEventHandlers = this.buildItemEventHandler();
listParams.container$elForImageLazyLoad = this._container$elForImageLazyLoad;
listParams.doNotInitializeLazyLoadingAtRender = this._doNotInitializeLazyLoadingAtRender;
const infiniteListView = new TrebbleAlbumListView(listParams);
this.infiniteListView = infiniteListView;
    

    infiniteListView.render();
    this._onOrientationChangeFunction(PersistentModels.getInstance().getRouter().getViewportHeight(), true);
    this.$el.on("remove",this._onNodeRemovedFromDom.bind(this));
//this.listenTo(this.infiniteListView, "songRemovedFromTrebble",this.onSongRemovedFromTrebble.bind(this));
//this.listenTo(this.infiniteListView, "actionExecutedOnSongHandler",this.onActionExecutedOnSongHandler.bind(this));
    return this;
}

});

export default AlbumListView;
